import { createSelector } from 'reselect'
import { identity, includes } from 'ramda'
import { List } from 'immutable'
import { getIn, pick, get, getOr, safeToJS } from 'utils/immutable'
import { NOT_SINGLE_CONDITION_NAMES } from 'utils/constants'

export const queriesSelector = getIn(['feature', 'currentFeature', 'queries'])

const querySelector = (state, props) =>
  state.getIn([
    'feature',
    'currentFeature',
    'queries',
    props.uri || props.queryUri,
  ])

const queryEvaluationSelector = (state, props) =>
  state.getIn([
    'feature',
    'currentFeature',
    'queries',
    props.parentId,
    props.rungNameResult,
  ])

const getQueryFirstFunctionUri = (uriPropName) => (state, props) =>
  state.getIn([
    'feature',
    'currentFeature',
    'queries',
    props[uriPropName],
    'functionUris',
    0,
  ])

const queryConditionsSelector = createSelector(
  querySelector,
  getOr(List(), 'conditions')
)

// TODO: below is deprecated, remove all instances
const old_queryUrisByFunctionidSelector = (id) =>
  getIn(['feature', 'currentFeature', 'functions', id, 'queries'])
const queryUrisByFunctionidSelector = (state, { id }) =>
  state.getIn(['feature', 'currentFeature', 'functions', id, 'queries'])

const functionQueriesSelector = (id) =>
  createSelector(old_queryUrisByFunctionidSelector(id), queriesSelector, pick)

// TODO: delete
const makeGetQueryEvaluation = () =>
  createSelector(queryEvaluationSelector, identity)
const getQueryDescription = createSelector(querySelector, get('description'))
const makeGetQueryDescription = () => getQueryDescription

export {
  getQueryFirstFunctionUri,
  queryConditionsSelector,
  functionQueriesSelector,
  old_queryUrisByFunctionidSelector,
  queryUrisByFunctionidSelector,
  makeGetQueryEvaluation,
  makeGetQueryDescription,
  querySelector,
}

export const getQueryType = createSelector(querySelector, get('queryType'))

export const getIsSingleCondition = createSelector(
  getQueryType,
  includes(NOT_SINGLE_CONDITION_NAMES)
)

export const makeTimerConditionsSelector = () =>
  createSelector(queryConditionsSelector, safeToJS)
